export default "__VITE_ASSET__BMk6gXCY__"